import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { API } from "../../../helpers/constants";
import { handleAxiosErrors, logoutUnauthorizedUser } from "../../../helpers/errorHandling";
import { getRouteUrl } from "../../../helpers/routing/getRouteUrl";
import useUserAction from "../../../hooks/user/useUserAction";
import useUserData from "../../../hooks/user/useUserData";
import { ISSUES_FORM } from "../locales/namespaces";
import { ROUTE_PAGE_ISSUES_EDIT } from "../routes/routes";

const useFollowUp = () => {
	const history = useHistory()
	const { t } = useTranslation(ISSUES_FORM)
	const [loading, setLoading] = useState(false)
	const { token, isLoggedIn } = useUserData()
	const { userLogout } = useUserAction()
	
	const followUp = useCallback((issueId) => {
		setLoading(true)
		axios({
			method: 'post',
			url: `${API}/en/issues/followup/${issueId}`,
			headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
		}).then(response => {
			setLoading(false)
			const newIssueId = response?.data?.IssueId
			if (newIssueId) history.push(getRouteUrl(ROUTE_PAGE_ISSUES_EDIT, { IssueId: newIssueId }))
		}).catch(error => {
			enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
				variant: 'error',
				autoHideDuration: 3000,
			})
			setLoading(false)
			logoutUnauthorizedUser(error, isLoggedIn, userLogout)
		})
	}, [t, isLoggedIn, userLogout, history])
	
	return {
		loading,
		followUp
	}
}

export default useFollowUp